/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface JiraStatusSync
 */
export interface JiraStatusSync {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof JiraStatusSync
     */
    statusMap?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSync
     */
    defaultCfStatusId?: string;
    /**
     * 
     * @type {string}
     * @memberof JiraStatusSync
     */
    defaultJiraStatusName?: string;
}

export function JiraStatusSyncFromJSON(json: any): JiraStatusSync {
    return {
        'statusMap': !exists(json, 'statusMap') ? undefined : json['statusMap'],
        'defaultCfStatusId': !exists(json, 'defaultCfStatusId') ? undefined : json['defaultCfStatusId'],
        'defaultJiraStatusName': !exists(json, 'defaultJiraStatusName') ? undefined : json['defaultJiraStatusName'],
    };
}

export function JiraStatusSyncToJSON(value?: JiraStatusSync): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'statusMap': value.statusMap,
        'defaultCfStatusId': value.defaultCfStatusId,
        'defaultJiraStatusName': value.defaultJiraStatusName,
    };
}


